// stores/settings.ts
// @ts-ignore
import { defineStore } from 'pinia';

interface SettingsState {
  publicSettings: Record<string, any>;
  authSettings: Record<string, any>;
  settings: Record<string, any>;
}

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsState => ({
    publicSettings: {},
    authSettings: {},
    settings: {},
  }),

  actions: {
    // Fetch public settings
    async fetchPublicSettings() {
      if (process.server) return;

      try {
        const response = await $fetch('settings');
        if (response?.data) {
          this.publicSettings = response.data;
          this.mergeSettings();
        } else {
          console.warn('No public settings data found in response:', response);
        }
      } catch (error) {
        console.error('Error fetching public settings:', error);
      }
    },

    // Fetch authenticated settings
    async fetchAuthSettings() {
      try {
        const response = await $fetch('settings/auth');
        if (response?.data) {
          this.authSettings = response.data;
          this.mergeSettings();
        } else {
          // console.warn('No authenticated settings data found in response:', response);
        }
      } catch (error) {
        console.error('Error fetching authenticated settings:', error);
      }
    },

    // Merge public and auth settings
    mergeSettings() {
      this.settings = {
        ...this.publicSettings,
        ...this.authSettings,
      };
    },
  },
});
